import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { elecFinanceInfo, initialState } from 'app/core/models/slice/sbk/sbk'

const slice = createSlice({
    name: 'elecFinanceInfo',
    initialState,
    reducers: {
        clearElecFinanceInfo: (state) => {
            state = { ...initialState }
        },
        setElecFinanceInfo: (state, action: PayloadAction<elecFinanceInfo>) => {
            state.allPdcd = action.payload.allPdcd
            state.smbkGubun = action.payload.smbkGubun
            state.secuMdiaDcd = action.payload.secuMdiaDcd
            // state = action.payload
        },

        setCertInfo: (state, action: PayloadAction<elecFinanceInfo>) => {
            state.certStatus = action.payload.certStatus
            state.certSerial = action.payload.certSerial
            state.userDn = action.payload.userDn
            state.userId = action.payload.userId
            state.validFrom = action.payload.validFrom
            state.validTo = action.payload.validTo
        },

        setSecuMdiaDcd: (state, action: PayloadAction<string>) => {
            state.secuMdiaDcd = action.payload
        },

        setOtpInfo: (state, action: PayloadAction<elecFinanceInfo>) => {
            state.otpIobDcd = action.payload.otpIobDcd
            state.otpCopcd = action.payload.otpCopcd
            state.otpUqn = action.payload.otpUqn
            state.cdNm = action.payload.cdNm
        },

        setTransferLimitInfo: (
            state,
            action: PayloadAction<elecFinanceInfo>
        ) => {
            state.itbkPcstTtalTrlmAmt = action.payload.itbkPcstTtalTrlmAmt
            state.itbkDatfLmtAmt = action.payload.itbkDatfLmtAmt
            state.itbkRnd1TrlmAmt = action.payload.itbkRnd1TrlmAmt

            state.otpUtlRngDcd = action.payload.otpUtlRngDcd
            state.ovrsIpIntcYn = action.payload.ovrsIpIntcYn

            state.cusAcn = action.payload.cusAcn
            state.acntPwd = action.payload.pwd

            state.ebkFrdPrveSrapDcd = action.payload.ebkFrdPrveSrapDcd
            state.mngmBrcd = action.payload.mngmBrcd

            state.smsRcctYn = action.payload.smsRcctYn
            state.lmtAcntYn = action.payload.lmtAcntYn
        },
    },
})

export const {
    clearElecFinanceInfo,
    setElecFinanceInfo,
    setSecuMdiaDcd,
    setTransferLimitInfo,
    setOtpInfo,
    setCertInfo,
} = slice.actions

export default slice.reducer
